import Image from 'react-bootstrap/lib/Image'
import React from 'react'
import PropTypes from 'prop-types'
import {css} from 'glamor'

const style = {
  brand: css({
    height: '25px',
    maxWidth: '60px'
  })
}

const BrandLogo = ({serverHost, brand, small}) => {
  const url = encodeURI(
    `${serverHost}/api/stores/brandlogo/${brand
      .toLowerCase()
      .replace(/\//g, '_')
      .replace(/\./g, '')
      .replace(/&/g, 'and')}`
  )
  return <Image src={url} {...(small ? style.brand : {})} />
}

BrandLogo.propTypes = {
  serverHost: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  small: PropTypes.bool
}

BrandLogo.defaultProps = {
  small: false
}

export default BrandLogo
